import React, {useCallback, useLayoutEffect, useRef} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PatientInfoHeader from './patientInfoHeader';
import _ from 'lodash';
import {changePatientContextTab} from '../../../../store/reducers/patientContext';
import {useDispatch, useSelector} from 'react-redux';
import Typography from '@mui/material/Typography';
import PatientHeaderMainIcon from '../../../../components/patient/patientHeaderMainIcon';
import useMediaQuery from '@mui/material/useMediaQuery';
import PatientHeaderAdditionalButtons from '../../../../components/patient/patientHeaderAdditionalButtons';
import {patientConfig} from '../../../../store/reducers/externalConfig';

const useStyles = makeStyles((theme) =>
    ({
        header: {
            width: '100%',
        },
        cpis: {
            border: '1px solid #C62828',
            padding: 2,
            backgroundColor: '#C62828',
            borderRadius: 5,
            color: '#fff',
            fontWeight: 'bold',
            fontSize: 'medium',
            display: 'flex',
            alignItems: 'center',
        },
        noItem: {
            color: 'grey',
            cursor: 'default',
        },
    }),
);

const PatientContextHeader = ({patient, handleSaveData, patientObject, disableSave, pastAttendances}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const isLong = useMediaQuery('(min-width:1040px)');
    const patientCfg = useSelector(patientConfig);

    // Refs
    const patientInfoRef = useRef();
    const patientInfoHeaderRef = useRef();

    useLayoutEffect(() => {
        if (!patientInfoRef.current) return;

        const resizeObserver = new ResizeObserver(() => {
            if (patientInfoRef?.current?.getBoundingClientRect()?.width) {
                patientInfoHeaderRef?.current?.style.setProperty('flex-basis', `calc(100% - ${patientInfoRef?.current?.getBoundingClientRect()?.width + 5}px)`);
            }
        });
        resizeObserver.observe(patientInfoRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, [patientInfoRef?.current, patientInfoHeaderRef?.current]);


    const handleOpenTimeline = () => {
        dispatch(changePatientContextTab('timeline'));
    };

    const selectedFlags = useCallback(() => {
        const patientFlags = _.get(patient, 'metadata.patientFlags', []);
        return _.filter(patientFlags, 'checked').length;
    }, [patient]);

    return (
        <div className={classes.header}>
            {patientObject &&
                <>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: {
                                    md: '1rem',
                                    lg: '1.25rem',
                                },
                            }}
                            fontWeight={700}
                        >
                            {patientObject?.familyName?.toUpperCase()}, {patientObject.firstName}
                        </Typography>

                        <PatientHeaderMainIcon
                            patient={patient}
                        />

                        {isLong &&
                            <PatientInfoHeader
                                patient={patient}
                            />
                        }

                        <div style={{float: 'right', marginRight: 5, marginLeft: (patientCfg?.demographicPosition === 'left' || !isLong) ? 'auto' : 'unset'}}>
                            <PatientHeaderAdditionalButtons
                                patient={patient}
                                disableSave={disableSave}
                                handleSaveData={handleSaveData}
                                pastAttendances={pastAttendances}
                            />
                        </div>
                    </div>

                    {!isLong &&
                        <div style={{marginTop: 10, marginRight: 10}}>
                            <PatientInfoHeader
                                patient={patient}
                            />
                        </div>
                    }
                </>

            }
        </div>
    );
};

export default PatientContextHeader;